__webpack_require__.p = "/widgets/vacancies/";